// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"c87fbb6b","496":"0edc77e3","792":"00ded139"}[chunkId] + ".chunk.css";
};